import { client } from '@/common-utils/libraries/axios/axios';
import { ORGANIZATION } from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationAddSimEmails = (onSuccess, onError) => {
    return {
        mutationFn: ({ organizationId, emails }) => {
            return client.post(replaceParameters(ORGANIZATION.SIM_ALERTS_RECEIVERS.url, { uuid: organizationId }), { mailList: emails });
        },
        onError: (error) => {
            onError(error);
        },
        onSuccess: () => {
            onSuccess();
        },
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationAddSimEmails;